import { Tooltip } from "@mui/material";
import React from "react";

interface RpMuiToolTipProps {
  children: React.ReactElement;
  content?: React.ReactNode;
  interactive?: boolean;
}

function RpMuiToolTip({
  children,
  content,
  interactive = false,
}: RpMuiToolTipProps) {
  return (
    <Tooltip
      title={<>{content}</>}
      disableInteractive={interactive}
      slotProps={{
        popper: {
          disablePortal: false,
          style: { zIndex: 99999 },
        },
        tooltip: {
          sx: {
            backgroundColor: "var(--neutral-white)",
            color: "text.primary",
            fontSize: "9px",
            padding: "6px 12px",
            boxShadow: "var(--shadow-floating)",
            "& .MuiTooltip-arrow": {
              color: "var(--neutral-white)",
            },
          },
        },
      }}
    >
      {children}
    </Tooltip>
  );
}

export default RpMuiToolTip;
